// Copyright (c) Microsoft. All rights reserved.

import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkSuperSub from 'remark-supersub';
import { IChatMessage } from '../../../libs/models/ChatMessage';
import * as utils from './../../utils/TextUtils';

const useClasses = makeStyles({
    content: {
        wordBreak: 'break-word',
        '& p': {
            marginTop: '0',
            marginBottom: '0',
        },
        '& pre': {
            backgroundColor: tokens.colorNeutralBackground6,
            color: tokens.colorNeutralForeground1,
            ...shorthands.padding('15px'),
        },
        '& code': {
            textWrap: 'wrap',
            ...shorthands.borderRadius('5px'),
        },
    },
    markdown: {
        '& a': {
            'text-decoration': 'none',
        },
    },
});

interface ChatHistoryTextContentProps {
    message: IChatMessage;
}

export const ChatHistoryTextContent: React.FC<ChatHistoryTextContentProps> = ({ message }) => {
    const classes = useClasses();

     const content =
         message.content === '{}'
             ? "I am sorry, but I can't find anything related to your question."
             : utils.formatChatTextContent(message);

    return (
        <div className={classes.content}>
            <ReactMarkdown
                className={classes.markdown}
                remarkPlugins={[remarkGfm, remarkSuperSub]}
                components={{ sub: 'sub', sup: 'sup' }}
            >
                {content}
            </ReactMarkdown>
        </div>
    );
};
